import Layout from '@components/Layout/Layout.component';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '@utils/auth';

export const Route = createFileRoute('/(dashboard)/_dashboard')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({
        to: '/login',
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
